import React from 'react';

import {EventCodeGenerationController, EventReviewFeedback} from 'src/modules/ai';
import {EVENT_CODE_FIELD_NAME} from 'src/modules/ai/constants';
import {useIsInReviewStatus} from 'src/modules/event-review/hooks/useIsInReviewStatus';
import {ChangeRequest} from 'src/openapi/models/ChangeRequest';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Group} from '@pb/kit-component-group';

type Props = {
    changeRequest: ChangeRequest,
};

export const EventCode = ({changeRequest}: Props) => {
    const isInReviewStatus = useIsInReviewStatus(changeRequest);

    return (
        <Group direction="v" gap="xxs" justify="space-between">
            <Group>
                <strong>Event Code:</strong>
                <EventReviewFeedback changeRequestId={changeRequest.id} fieldName={EVENT_CODE_FIELD_NAME}/>
            </Group>
            <Group>
                <EllipsisTextHint>{changeRequest.event.code}</EllipsisTextHint>

                {isInReviewStatus ? (
                    <EventCodeGenerationController eventChangeRequest={changeRequest.event}/>
                ) : null}
            </Group>
        </Group>
    );
};
